// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsList {
  width: 1200px;
  margin: 0px auto;
  display: flex;
  padding-bottom: 30px;
}
.newsList-right {
  padding-left: 20px;
}
.newsList-right li {
  border-bottom: 1px dashed #ddd;
  padding: 10px;
}
.newsList-right li h3 {
  margin: 0px;
  line-height: 26px;
}
.newsList-right li h3 a {
  color: #333;
  font-size: 15px;
}
.newsList-right li .text {
  font-size: 14px;
  color: #666;
  line-height: 30px;
  padding-top: 5px;
}
.newsList-right li .bottom {
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  padding-top: 10px;
  line-height: 30px;
}
.newsList-right li .bottom a {
  color: #3567d7;
}
.newsList-right li .bottom span {
  color: #999;
  font-size: 12px;
}
.newsList-right li:nth-of-type(2n+1) {
  background: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/News/index.less"],"names":[],"mappings":"AAAA;EAAU,aAAA;EAAc,gBAAA;EAAiB,aAAA;EAAe,oBAAA;AAKxD;AAJG;EAAQ,kBAAA;AAOX;AAPG;EACM,8BAAA;EAAgC,aAAA;AAUzC;AAXG;EAES,WAAA;EAAa,iBAAA;AAazB;AAfG;EAGW,WAAA;EAAY,eAAA;AAgB1B;AAnBG;EAKY,eAAA;EAAgB,WAAA;EAAY,iBAAA;EAAmB,gBAAA;AAoB9D;AAzBG;EAMc,aAAA;EAAe,eAAA;EAAgB,8BAAA;EAAgC,iBAAA;EAAkB,iBAAA;AA0BlG;AAhCG;EAOW,cAAA;AA4Bd;AAnCG;EAQc,WAAA;EAAY,eAAA;AA+B7B;AAvCG;EAWwB,mBAAA;AA+B3B","sourcesContent":[".newsList{width:1200px; margin:0px auto; display: flex; padding-bottom:30px;\n   &-right{padding-left:20px;\n      li{border-bottom: 1px dashed #ddd; padding:10px;\n         h3{margin: 0px; line-height:26px;;\n            a{color:#333; font-size: 15px;}\n         }\n         .text{font-size:14px; color:#666; line-height: 30px; padding-top:5px;}\n         .bottom{display: flex; font-size:14px; justify-content: space-between; padding-top:10px; line-height: 30px;\n            a{color:#3567d7;}\n            span{color:#999; font-size: 12px;}\n         }\n      }\n      li:nth-of-type(2n+1){background:#f5f5f5;}\n   }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
